import React, {useRef, useState, useEffect,} from "react";
import * as PropTypes from "prop-types";
import classNames from "classnames";
import {Dropdown, Input, Layout, Menu} from '@cloud/atom-ui';
import * as css from './index.m.css';
import history from '@src/utils/history';
import {i18n} from '@src/utils/i18n';
import {unique, compareDate} from '@src/utils/common';
import * as nls from './nls';
import * as actions from '@src/actions/index';
import useMappedState from '@src/utils/useMappedState';
import {useDispatch} from 'redux-react-hook';
import newLogo from '@src/assets/news.svg'
import New from './assets/NEW.svg'
import newLogoDefault from '@src/assets/newsDefault.svg'
import {getComfirmNewsData} from './thunk'
import SearchOutlined from '@cloud/atom-ui-icons/SearchOutlined';
import DownOutlined from '@cloud/atom-ui-icons/DownOutlined';
import {urlDomainDeal} from "@src/utils/common";

const I18N = i18n(nls);
const {Header} = Layout;

let _menuStack = [];
const _openKeys = {};
let selectedKey = [];
const getSelectedKey = () => {
  return selectedKey;
};
let _scoptId = "";
const getScoptId = () => {
  return _scoptId;
};
const isInited = {};
const urlKeyMaps = {};
let rerenderSideMenu = () => {
};
if (typeof window !== "undefined") {
  function HashHandler() {
    const href = window.location.href.replace(
      /[^/]*\/\/[^/]+(\/[^?#]*)[^#]*(#[^?]*).*/,
      "$1$2"
    );
    if (urlKeyMaps[href]) {
      selectedKey = [urlKeyMaps[href]];
      rerenderSideMenu([urlKeyMaps[href]]);
    }
  }

  window.addEventListener("hashchange", HashHandler, false);
}
const _getOpenKeys = (correntRootId, level) => {
  if (!_openKeys[getScoptId()][correntRootId])
    _openKeys[getScoptId()][correntRootId] = {
      ..._openKeys[getScoptId()].DEFAULT
    };
  if (!_openKeys[getScoptId()][correntRootId][level]) {
    let bigestLevel = Object.keys(_openKeys[getScoptId()])
      .sort()
      .pop();
    return (
      (bigestLevel && _openKeys[getScoptId()][correntRootId][bigestLevel]) || []
    );
  } else {
    return _openKeys[getScoptId()][correntRootId][level];
  }
};


const Headers = props => {
  let {
    homeClick,
    navItemData,
    navItemClick,
    user,
    lang,
    dropDownComponent,
    prefixCls = "amu-headers",
    selectable = false,
    logo,
    activeMenu,
    locale,
  } = props;

  logo = {
    ...{
      text: "",
      url: "",
      alt: "",
      style: {}
    },
    ...logo
  };
  const {name, nameEn} = user;
  const {confirmNewsIndex, siteType} = useMappedState('root');
  const {user: users} = useMappedState('root');
  const dispatch = useDispatch();
  const [activeMenuKey, setActiveMenuIndex] = useState("");
  const [newsData, setNewsData] = useState([]) // 最新的通知信息数据列表
  const [newsToTalCnt, setNewsToTalCnt] = useState(0) // 总的数量
  const [realTimeActive, setRealTimeActive] = useState([])
  const [Time, setTime] = useState('')
  const isMatched = useRef(false);
  const [searchContent, setSearchContent] = useState((localStorage.searchWord || ''));

  // 菜单activeKey
  const [menuActiveKey, setMenuActiveKey] = useState(["devbench-app-dev"])

  useEffect(()=>{
    const urlHash = window.location.hash;
    navItemData.forEach(item=>{
      if(item?.menuUrl === urlHash){
        setMenuActiveKey([item?.id])
      }
    })
  },[window.location.href])

  const searchApp = (event) => {
    event.persist();
    history.push('/search?timestamp='+Date.now())
  }
  let iconStatus = localStorage.getItem('IconStatus')
  useEffect(() => {
    let locId = localStorage.getItem('accountId')
    if (users) {
      if (locId !== users.accountid) {
        localStorage.removeItem('newIndex');
        localStorage.removeItem('newNumber')
        localStorage.setItem('accountId', users.accountid)
      } else {
        localStorage.setItem('accountId', users.accountid)
      }
    }
  }, [users])
  //
  useEffect(() => {
    getSourceData();
    if (localStorage.getItem('newIndex')) {
      dispatch(actions.confirmNewsIndex(localStorage.getItem('newIndex')))
    }
  }, [])
//  获取 通知中心数据列表
  const getSourceData = () => {
    getComfirmNewsData(1, 10).then(res => {
      if (res.status === 1) {
        let data = res.data;
        let newArrayData = data.list.filter(function (value, index, array) {
          return value.noticeStatus === 1
        })
        if (data.list && data.list.length > 0) {
          if (data.list[0].noticeStatus === 1) {
            let effData = data.list[0].effectiveDate
            setTime(effData)
            if (localStorage.getItem('effectiveTime')) {
              if (compareDate(effData, localStorage.getItem('effectiveTime'))) {
                localStorage.setItem('IconStatus', 2)
              } else {
                localStorage.setItem('IconStatus', 1)
              }
            } else {
              localStorage.setItem('IconStatus', 2)
            }
          } else {
            localStorage.setItem('IconStatus', 1)
          }
        } else {
          localStorage.setItem('IconStatus', 1)
        }
        setNewsData(newArrayData.slice(0, 5))
        setNewsToTalCnt(data.effectiveNoticeCnt)
      } else {
        localStorage.setItem('IconStatus', 1)
        setNewsData([])
        setNewsToTalCnt(0)
      }
    }).catch(error => {
      localStorage.setItem('IconStatus', 1)
    })
  }
  navItemData = navItemData.filter(item => item.isShowMenu != 0)
  let href = "";
  if (typeof window !== "undefined") {
    href = window.location.href.replace(
      /[^/]*\/\/[^/]+(\/[^?#]*)[^#]*(#[^?]*).*/,
      "$1$2"
    );
  }
  //渲染子组件
  const RenderMenu = ({
                        menu,
                        index,
                        navItemClick,
                        en,
                        isRoot,
                        menuStack,
                        level
                      }) => {
    let {name, nameEn, menuName, dataIndex, id, menuUrl} = menu;
    menuUrl = menuUrl || ""; // null
    const key = dataIndex || id;
    const shortMenuUrl = menuUrl.replace(
      /[^/]*\/\/[^/]+(\/[^?#]*)[^#]*(#[^?]*).*/,
      "$1$2"
    );

    // 维护 url 与 key map，供 hashChange 时获取 key
    shortMenuUrl && (urlKeyMaps[shortMenuUrl] = key);

    if (!isMatched.current) {
      menuStack[level] = menu;
    }
    if (!activeMenu && !isMatched.current && href === shortMenuUrl) {
      setActiveMenuIndex(key);
      isMatched.current = true;
      _menuStack = menuStack;
      if (!isInited[key]) {
        _scoptId = menuStack[0].id || menuStack[0].dataIndex;
        getOpenKeys([menuStack[0]]);
      }
    }
    if (activeMenu && !isMatched.current && activeMenu === key) {
      setActiveMenuIndex(key);
      isMatched.current = true;
      _menuStack = menuStack;
      if (!isInited[key]) {
        _scoptId = menuStack[0].id || menuStack[0].dataIndex;
        getOpenKeys([menuStack[0]]);
      }
    }
    if (href === shortMenuUrl) {
      if (!isInited[key]) {
        selectedKey.push(key);
        isInited[key] = true;
      }
    }

    function getId({menu, level, allStacks}) {
      const {subResList, index, id, dataIndex} = menu;
      if (subResList) {
        level++;

        if (!_openKeys[getScoptId()]) _openKeys[getScoptId()] = {};
        if (!_openKeys[getScoptId()].DEFAULT)
          _openKeys[getScoptId()].DEFAULT = {};
        if (!_openKeys[getScoptId()].DEFAULT[level])
          _openKeys[getScoptId()].DEFAULT[level] = [];
        subResList.map(menu => {
          const {id, dataIndex} = menu;
          allStacks.push(id || dataIndex);
        });
        if (!_openKeys[getScoptId()].DEFAULT[level].length)
          _openKeys[getScoptId()].DEFAULT[level] = [...allStacks];

        subResList.map(menu => {
          getId({menu, level, allStacks});
        });
      }
    }

    function getOpenKeys(menuStack) {
      menuStack.map((menu, index) => {
        const {id, dataIndex} = menu;
        const allStacks = [];
        const level = 0;
        allStacks.push(id || dataIndex);
        if (!_openKeys[getScoptId()]) _openKeys[getScoptId()] = {};
        if (!_openKeys[getScoptId()].DEFAULT)
          _openKeys[getScoptId()].DEFAULT = {};
        if (!_openKeys[getScoptId()].DEFAULT[level])
          _openKeys[getScoptId()].DEFAULT[level] = [];
        _openKeys[getScoptId()].DEFAULT[level] = [...allStacks];

        getId({menu, level, allStacks});
      });
    }

    return (
      <Menu.Item
        style={{
          paddingRight: '20px',
          display: 'inline-block',
          top: '0',
          verticalAlign: 'bottom',
          lineHeight: '60px'
        }}
        key={key}
        onClick={() => {
          navItemClick(menu, index);
        }}
      >
        {menuName || (en ? nameEn : name)}
      </Menu.Item>
    );
  };
  const [profileVisible, setProfileVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  //渲染尾标
  const SearchSuffix = props => {
    return (<div>
      <SearchOutlined style={{margin: '0 5px'}} className={css['certain-category-icon']} onClick={() => {
        dispatch(actions.searchFlag(true))
        history.push('/search')
      }}/>
    </div>)
  };
  // 通知信息列表
  const confirmList = <div className={css['confirm-wrapper']}>
    {
      newsData && newsData.length ? <div className={css['new-count']}>您有新消息</div> :
        <div className={css['no-news']}>暂无最新消息</div>
    }
    <ul className={css['new-items']}>
      {
        newsData && newsData.length > 0 && newsData.map((item, index) => {
          return (
            <li className={css['new-item']} key={index} onClick={() => {
              handleCheckNews(item.id, item)
            }}>
              <div className={css['new-context']}>
                <span
                  className={css[item.urlLink && item.noticeStatus == 1 ? 'new-titlehref' : 'new-title']}>{item.contentZh}</span>
                {
                  confirmNewsIndex && confirmNewsIndex.indexOf(item.id) > -1 || item.noticeStatus !== 1 ? null :
                    <img className={css['centreitem-imgNew']} src={New}/>
                }
              </div>
              <div className={css['new-time']}>{item.effectiveDate}</div>
            </li>
          )
        })
      }
    </ul>
    <div className={css['new-readmore']} onClick={() => {
      jumpToMorePage()
    }}>查看更多消息
    </div>
  </div>
  const en =
    (locale || lang || "en-us").search("en") === 0;
  // 点击是否查看过文档
  const handleCheckNews = (val, item) => {
    let allNews = localStorage.getItem('newIndex')
    let newAllNews;
    if (allNews) {
      newAllNews = allNews.split(",");
      newAllNews.push(val)
      localStorage.setItem('newIndex', unique(newAllNews))
      dispatch(actions.confirmNewsIndex(localStorage.getItem('newIndex')))
    } else {
      newAllNews = [val];
      localStorage.setItem('newIndex', unique(newAllNews))
      dispatch(actions.confirmNewsIndex(localStorage.getItem('newIndex')))
    }
    localStorage.setItem('newNumber', newAllNews.length)
    dispatch(actions.confirmNewsNumber(Number(localStorage.getItem('newNumber'))))
    setRealTimeActive(newAllNews)
    if (item.urlLink) {
      window.open(item.urlLink, '_blank')
    } else {
      history.push('/newsConfirm')
    }
  }
  // 跳转到更多的页面
  const jumpToMorePage = () => {
    history.push('/newsConfirm')
  }
  //
  const handleonVisibleChange = () => {
    localStorage.setItem('IconStatus', 1)
    localStorage.setItem('effectiveTime', Time)
    setConfirmVisible(!confirmVisible)
  }

  return <Header className={[css[`${prefixCls}-container`], 'customHeader']}>
    <div className={css[`${prefixCls}-logo-icon`]}>
      <div className={css[`amu-headers-logo-icon-img`]} onClick={homeClick}>
        {logo.url && (
          <>
            <img
              src={urlDomainDeal(logo.url)}
              alt={logo.alt}
              style={logo.style}
            />
            <span className={css["logoTitle"]}>开放平台</span>
          </>

        )}
      </div>
    </div>
    <Menu
      selectable={selectable}
      className={[css['amu-headers-menu'], 'customHeader']}
      theme="light"
      mode="horizontal"
      defaultSelectedKeys={menuActiveKey}
      selectedKeys={menuActiveKey}
    >
      {navItemData.map((menu, index) => {
        return RenderMenu({
          menu,
          index,
          navItemClick,
          en,
          isRoot: true,
          menuStack: [],
          level: 0
        });
      })}
    </Menu>

    <Input className={css['search-input']}
           style={{marginLeft: 'auto'}}
           placeholder={I18N.typePlacehold}
           size="small"
           suffix={SearchSuffix()}
           onPressEnter={searchApp}
           value={searchContent}
           allowClear
           onChange={e => {
             setSearchContent(e.target.value)
             localStorage.setItem('searchWord', e.target.value)
           }}
    />
    {
      siteType && siteType.site_type != 2 &&
      <Dropdown
        visible={confirmVisible}
        onVisibleChange={() => {
          handleonVisibleChange()
        }}
        overlay={confirmList}
        placement="bottomCenter"

      >
        <div
          style={{
            float: "right",
            color: "#008DFF",
            lineHeight: '60px',
            marginLeft: '12px',
            position: "relative",
            marginRight: "10px"
          }}
        >
          <span className={css['countIcon']}>
            <img src={confirmVisible ? newLogo : newLogoDefault}/>
          </span>
          {/*  到时候陈俊对下  */}
          {iconStatus == 1 ? null : <span className={css['newLogo-count']}></span>}
        </div>
      </Dropdown>
    }

    {/*  用户姓名与账户 */}
    <Dropdown
      visible={profileVisible}
      onVisibleChange={setProfileVisible}
      overlay={dropDownComponent}
      placement="bottomRight"
    >
      <div
        style={{
          float: "right",
          color: "#008DFF",
          lineHeight: '60px',
          marginLeft: siteType && siteType.site_type != 2 ? '12px' : '60px'
        }}
        className={[profileVisible ? `${css.hover}` : '', css['right-item']]}
      >
        <span className={css.username}>{en ? nameEn : name}</span>
        <DownOutlined className={css.arrow}/>
      </div>
    </Dropdown>
  </Header>;
};
Headers.defaultProps = {
  showMore: false,
  showMoreLinks: [],
  showMenuLevel: 2,
  filter: menu => menu.isShowMenu != "0"
};
Headers.propTypes = {
  user: PropTypes.object,
  lang: PropTypes.string,
  homeClick: PropTypes.func,
  navItemClick: PropTypes.func,
  dropDownComponent: PropTypes.node
};

Headers.SideMenu = props => {
  const prefixCls = "amu";
  const {
    rootLevel,
    onItemClick,
    autoExpandMenuLevel,
    selectedKeys: selected_keys,
    onSelect,
    style,
    filter
  } = props;
  if (rootLevel < 2) {
    throw new Error("rootLevel must be greater than 2.");
  }
  const menuStack =
    _menuStack[rootLevel - 2] && (_menuStack[rootLevel - 2].subResList || []);
  const correntRootId =
    (_menuStack[rootLevel - 2] && _menuStack[rootLevel - 2].id) || "";

  const RenderMenu = (menu, index) => {
    const {
      name,
      menuName,
      dataIndex,
      id,
    } = menu;
    const key = dataIndex || id;
    // 是否显示当前菜单
    let hideCurrent = !filter(menu);

    return (
      <Menu.Item
        className={classNames({
          hideCurrent: hideCurrent
        })}
        key={key}
        onClick={() => {
          onItemClick(menu, index);
        }}
        style={{overflow: "hidden", textOverflow: "ellipsis"}}
      >
        <span className={`${prefixCls}-side-menu-none-icon-flag`}/>
        {menuName || name}
      </Menu.Item>
    );
  };

  const openKeysProp = autoExpandMenuLevel + rootLevel - 2;
  if (!menuStack || !menuStack.length) {
    return null;
  }
  const [keys, setKeys] = useState(_getOpenKeys(correntRootId, openKeysProp));
  const [selectedKeys, setSelectedKeys] = useState(getSelectedKey());
  rerenderSideMenu = setSelectedKeys;
  return (
    <Menu
      inlineIndent={15}
      mode="inline"
      openKeys={keys}
      onOpenChange={keys => {
        _openKeys[getScoptId()][correntRootId][openKeysProp] = keys;
        setKeys(keys);
      }}
      defaultOpenKeys={keys}
      onSelect={({item, key, keyPath, selectedKeys, domEvent}) => {
        selectedKey = selectedKeys;
        setSelectedKeys(selectedKeys);
        onSelect({item, key, keyPath, selectedKeys, domEvent});
      }}
      selectedKeys={selected_keys || selectedKeys}
      defaultSelectedKeys={selected_keys || selectedKeys}
      className={`${prefixCls}-side-menu`}
      style={{...style, height: "100%"}}
    >
      {menuStack.map((menu, index) => {
        return RenderMenu(menu, index);
      })}
    </Menu>
  );
};
Headers.SideMenu.defaultProps = {
  rootLevel: 2,
  autoExpandMenuLevel: 2,
  selectedKeys: null,
  onSelect: ({item, key, keyPath, selectedKeys, domEvent}) => {
  },
  onItemClick: (menu, index) => {
  },
  onTitleClick: (menu, index) => {
  },
  filter: menu => menu.isShowMenu != "0"
};

export default Headers;
